import { render, staticRenderFns } from "./HeaderBottom.vue?vue&type=template&id=973c7646&lang=pug&"
import script from "./HeaderBottom.vue?vue&type=script&lang=js&"
export * from "./HeaderBottom.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBottom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('973c7646')) {
      api.createRecord('973c7646', component.options)
    } else {
      api.reload('973c7646', component.options)
    }
    module.hot.accept("./HeaderBottom.vue?vue&type=template&id=973c7646&lang=pug&", function () {
      api.rerender('973c7646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/HeaderBottom.vue"
export default component.exports